import { useEffect, useRef, useState } from 'react';

export const MeasuredChart = ({ children, className = 'h-72' }) => {
  const containerRef = useRef(null);
  const [size, setSize] = useState(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;
    const update = () => {
      const bounds = container.getBoundingClientRect();
      if (bounds.width > 0 && bounds.height > 0) {
        setSize({ width: Math.floor(bounds.width), height: Math.floor(bounds.height) });
      }
    };
    const observer = new ResizeObserver(update);
    observer.observe(container);
    update();
    return () => observer.disconnect();
  }, []);

  return <div ref={containerRef} className={`min-w-0 ${className}`}>{size ? children(size) : null}</div>;
};
